import { useContext } from 'react';
import { ToastContainer } from 'react-bootstrap';

import ApiErrorItem from './ApiErrorItem';
import { AppContext } from 'src/context/app';

export default function ApiErrorList() {
  const [{ errors }] = useContext(AppContext);

  const toasts = errors.map((info) => <ApiErrorItem key={info.id} info={info} />);

  return (
    <ToastContainer position="top-end" className="p-3">
      {toasts}
    </ToastContainer>
  );
}
